import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultaMaterias } from '../../funciones/RetiroFunction';
import MensajeRetraso from "../../shared/MensajeRetraso";
import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';

import RetiroMateriasTable from './RetiroMateriasTable';

let deudaTSolic = "";
class RetiroMaterias extends Component {
    state = {
        materiasIns: []
    }

    constructor (props) {
        super(props)

        ConsultaMaterias ((resp) => {
            this.setState({
                materiasIns: resp
            })
        })
    }

    componentDidMount = () => {
        ConsultaDeuda ((resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    Mediante este módulo podrás retirar las materias que has inscrito previamente.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Para retirar una materia simplemente haz click en el botón <button style={{borderWidth: 1}} className="btn btn-xs btn-relleno-danger" ><i className="fa fa-trash-o"></i></button> y luego confirma dicho retiro.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong>IMPORTANTE: Una vez que retires la materia, no podrás volverla a inscribir</strong>
                </Col>
            </Row>
        </React.Fragment>
    )

    contenido = () => {
        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )

        if (deudaTSolic > 0) return (<MensajeRetraso />)

        let { materiasIns } = this.state;
        let materias = () => {
            if (materiasIns.length === 0) {
                return (
                    <tr>
                        <td colSpan={5} align="center">No has inscrito ninguna materia.</td>
                    </tr>
                )
            }else{
                return (
                    materiasIns.map(option => (
                        <RetiroMateriasTable
                            key = {option.id}
                            id = {option.id}
                            materia = {option.materia}
                            seccion = {option.seccion}
                            tipo = {option.tipo}
                            uc = {option.uc}
                            status = {option.status}
                            cantidad = {materiasIns.length}
                            updLista = {() => {
                                ConsultaMaterias ((resp) => {
                                    this.setState({
                                        materiasIns: resp
                                    }, () => {
                                        toast.info("Has realizado el proceso de retiro de materia con éxito, espera que sea verificado por Control de Estudios y Administración",{autoClose: 4000});
                                    })
                                }) 
                            }}
                            error = {() => {
                                toast.warning("Debes tener inscrita al menos una materia",{autoClose: 4000});
                            }}
                        />
                    ))
                )
            }
        }

        const styles = {
            padding: 5, fontSize: 12
        }

        return(
            <div className="table-responsive">
                <Table striped hover bordered>
                    <tbody>
                        <tr className="custon-back-color">
                            <td width="55%" style={styles}><strong>Materia</strong></td>
                            <td width="15%" align="center" style={styles}><strong>Sección</strong></td>
                            <td width="20%" align="center" style={styles}><strong>Tipo</strong></td>
                            <td width="10%" align="center" style={styles}><strong>U.C.</strong></td>
                            <td width="40px" align="center" style={styles}></td>
                        </tr>
                        {materias()}
                    </tbody>
                </Table>
            </div>
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-info">
                            <i className="fa fa-info-circle"></i> Materias Inscritas
                        </div>
                        <Row className="custom-mt-10">
                            <Col md={12}>{this.contenido()}</Col>
                        </Row>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Retiro de Materias</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default RetiroMaterias;


// WEBPACK FOOTER //
// ./src/views/EstAcademicos/RetiroMaterias.jsx